import { render, staticRenderFns } from "./pdca.vue?vue&type=template&id=13a7618f&scoped=true&"
import script from "./pdca.vue?vue&type=script&lang=js&"
export * from "./pdca.vue?vue&type=script&lang=js&"
import style0 from "./pdca.vue?vue&type=style&index=0&id=13a7618f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7618f",
  null
  
)

export default component.exports